import { AbstractControl } from '@angular/forms';
import { isValidIBAN } from 'ibantools';

export function notEquals(value: any) {
  return (control: AbstractControl) => {
    if (control && control.value === value) {
      return {
        notEquals: true,
      };
    }
    return null;
  };
}

export function ibanValidator(control: AbstractControl) {
  if (
    control &&
    control.value &&
    typeof control.value === 'string' &&
    control.value.toUpperCase
  ) {
    const value = control.value.toUpperCase().replace(/\s/g, '');
    const valid = isValidIBAN(value);
    if (!valid) {
      return {
        iban: true,
      };
    }
  }
  return null;
}
